const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.54 1.88A24.1 24.1 0 0 0 12 0a24.1 24.1 0 0 0-9.54 1.88A2.47 2.47 0 0 0 1 4.14v7.3a12.85 12.85 0 0 0 8.5 11.9l1.08.39A4.22 4.22 0 0 0 12 24a4.32 4.32 0 0 0 1.46-.26l1.07-.39A12.84 12.84 0 0 0 23 11.44v-7.3a2.47 2.47 0 0 0-1.46-2.26Z" fill="currentColor"></path></svg>';
export {
  a as default
};
